import { style } from "@vanilla-extract/css";

import { input } from "~/components/Input.css";
import { vars } from "~/styles/tokens.css";

// A <select> matches :read-only, which the shared box's hover rule excludes,
// so the hover border is restated for it here.
export const select = style([
  input,
  {
    selectors: {
      "&:hover:not(:disabled)": {
        borderColor: vars.color.borderStrong,
      },
    },
  },
]);
